// 首页三个列表展示数据
const shopPropsList = 'item/home';
// 道具详情
const shopPropsInfo = 'item/details';
// 所有道具
const shopPropsTypeList = 'item/list';
// 我的Item List All
const myItemAllList = 'item/my/list';
// 购买道具
const shopPropsBuy = 'item/my/buy';
// 设置道具
const shopPropSet = 'item/my/set';
// 应用中得道具
const shopPropUsingList = 'item/my/setting';

// 模板列表
const templateList = 'itemtemplate/list';
// 添加模板
const templateAdd = 'itemtemplate/insert';
// 修改模板
const templateUpdate = 'itemtemplate/update';
// 删除模板
const templateDelete = 'itemtemplate/delete';
// 切换模板
const templateChange = 'itemtemplate/change';

// 获取赠送道具列表
const shopPropGiftList = 'itemgift/presentlist';
// 接受别人赠送礼品
const shopPropAccept = 'itemgift/receive';
// 接受所有礼品
const shopPropAcceptAll = 'itemgift/receiveall';
// 赠送别人礼品
const shopPropSend = 'itemgift/send';
// 索要礼品
const shopPropAsk = 'itemgift/ask';
// 获取别人向你索要礼品列表
const shopPropAskList = 'itemgift/asklist';
// 拒绝或者接受别人索要
const shopPropHandleAsk = 'itemgift/handleask';
// 获取所有礼品操作得数量
const shopPropGiftCount = 'itemgift/count';

export {
  shopPropsList,
  shopPropsInfo,
  shopPropsTypeList,
  myItemAllList,
  shopPropsBuy,
  shopPropSet,
  shopPropUsingList,
  templateList,
  templateAdd,
  templateUpdate,
  templateDelete,
  templateChange,
  shopPropGiftList,
  shopPropAccept,
  shopPropAcceptAll,
  shopPropSend,
  shopPropAsk,
  shopPropAskList,
  shopPropHandleAsk,
  shopPropGiftCount
}